export default "__VITE_ASSET__DS$Dhw0W__"